const { debounce } = window.BAO.Utils
class StickyProductBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.buttonVisible = true
    this.footerVisible = true

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()
    this.buttonObserver = new IntersectionObserver(
      this.onButtonIntersect.bind(this),
      {
        root: null,
        rootMargin: `-${this.scrollOffset}px 0px 0px 0px`,
        threshold: 0,
      },
    )

    this.checkViewportSize = this.checkViewportSize.bind(this)

    this.debouncedResize = debounce(this.checkViewportSize, 50)
    this.listeners.add(window, 'resize', this.debouncedResize)
    this.checkViewportSize()
  }

  checkViewportSize () {
    const mq = window.matchMedia('(max-width: 999px)')

    if (!mq.matches) {
      this.buttonObserver.disconnect()
    } else {
      const productButton = this.externalEls?.['product-button'].element
      const footerEl = this.externalEls?.footer.element
      if (productButton && footerEl) {
        this.buttonObserver.observe(productButton)
        this.buttonObserver.observe(footerEl)
      }
    }
  }

  get scrollOffset () {
    return this.externalEls?.header.element?.clientHeight || 0
  }

  onButtonIntersect (entries) {
    entries.forEach((entry) => {
      if (entry.target === this.externalEls['product-button'].element) {
        const productButtonRect = entry.target.getBoundingClientRect()
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight
        this.buttonVisible =
          productButtonRect.top > viewportHeight ? true : entry.isIntersecting
      } else if (entry.target === this.externalEls.footer.element) {
        this.footerVisible = entry.isIntersecting
      }
    })
    this.classList.toggle(
      'spb-StickyProductBar-sticky',
      !(this.buttonVisible || this.footerVisible),
    )
  }
}

if (!customElements.get('sticky-product-bar')) {
  customElements.define('sticky-product-bar', StickyProductBar)
}
